export default (context) => {
  if (process.browser) {
    context.store.dispatch('user/guest/loadGuestUser', {
      cookies: context.$cookies,
    });
  }
};
